(function () {
  'use strict';

  function init() {
    var button = document.querySelector('[data-pm-back-to-top]');
    if (!button || button.dataset.pmBackToTopInit === '1') return;
    button.dataset.pmBackToTopInit = '1';

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var scrollThreshold = Math.min(480, Math.max(320, window.innerHeight * 0.55));
    var ticking = false;

    function setVisible(visible) {
      button.classList.toggle('is-visible', visible);
      button.setAttribute('aria-hidden', visible ? 'false' : 'true');
      button.tabIndex = visible ? 0 : -1;
    }

    function updateVisibility() {
      setVisible(window.scrollY > scrollThreshold);
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateVisibility);
      }
    }

    button.addEventListener('click', function () {
      if (reducedMotion) {
        window.scrollTo(0, 0);
        return;
      }

      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      scrollThreshold = Math.min(480, Math.max(320, window.innerHeight * 0.55));
      updateVisibility();
    });

    updateVisibility();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
